// extracted by mini-css-extract-plugin
var _1 = "fK4ZHznyZO";
var _2 = "FDeAcT5ajB";
export { _1 as "modifierPointer", _2 as "pointer" }
